import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Spin, Select, Input, Row, Col, DatePicker, Modal, Space } from 'antd';
import { SearchOutlined, RedoOutlined, DeleteOutlined, EyeOutlined, HomeOutlined, CloseCircleOutlined } from '@ant-design/icons';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import Message from '../../component/message/message';
import trans from './translation';

const { Option } = Select;
const { RangePicker } = DatePicker;

const SchedulingLog = (props) => {
    const messageRef = useRef();
    const [tables, setTables] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState("");
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [tablesCount, setTablesCount] = useState(0);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [jobGroupList, setJobGroupList] = useState([]);
    const [isView, setIsView] = useState(false);
    const [viewModel, setViewModel] = useState({});
    const [popupType, setPopupType] = useState("");

    useEffect(() => {
        search(pageSize, 1, "N");
        searchJobGroup();
    }, []);

    const searchJobGroup = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "SYS_JOB_GROUP" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                setJobGroupList(data.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();//清除提示信息
        clearSelect();//清除選中狀態
        let model = {};
        if ("Y" === flag) {//是否使用原查詢條件
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.page = currentPageNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("sysJobLog/search", model).then((data) => {
            if ("SUCCESS" == data.msg) {
                if (Base.isEmpty(data.object.list) && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const searchChange = (key, value) => {
        setSearchModel(model => {
            let newModel = {};
            if (key === "time") {
                newModel.beginTime = value[0];
                newModel.endTime = value[1];
                return { ...model, ...{ beginTime: value[0], endTime: value[1] } };
            } else {
                return { ...model, ...{ [key]: value } };
            }
        });
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        messageShowHandler();
        setViewModel(model);
        setDeleteMsg(trans.confirmDelete[Config.backLang]);
        setPopupType("delete")
        setIsDeleteFrame(true);
    }

    const clearFrameHandler = () => {
        messageShowHandler();
        setDeleteMsg(trans.empty[Config.backLang]);
        setPopupType("clear");
        setIsDeleteFrame(true);
    }

    const deleteFrameClose = (state) => {
        if (state) {
            if (popupType === "delete") {
                deleteLog();
            } else if (popupType === "clear") {
                claerLog();
            }
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteLog = () => {
        let model = {
            menuFuncId: Config.funcInfo.funcId,
            jobLogIds: [viewModel.jobLogId],
        }
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang]);
        Base.callBackApi("sysJobLog/delete", model).then((data) => {
            if ("SUCCESS" == data.msg) {
                search(pageSize, current, "Y");
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    }

    const claerLog = () => {
        let model = {
            menuFuncId: Config.funcInfo.funcId,
        }
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang]);
        Base.callBackApi("sysJobLog/clean", model).then((data) => {
            if ("SUCCESS" == data.msg) {
                search(pageSize, current, "Y");
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false);
        });
    }

    const view = (model, e) => {
        e.stopPropagation();
        setViewModel(model);
        setIsView(true);
    }

    const viewClose = () => {
        setViewModel({});
        setIsView(false);
    }

    //分页 页码切换变化查询
    const onChange = (current, pageSize) => {
        search(pageSize, current, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (current, pageSize) => {
        search(pageSize, 1, "Y");
    }

    //列表1选中记录
    const onSelectChange = (keys, selectedRows) => {
        setSelectedRowKeys(keys);
        setCheckboxState(selectedRows);
    }

    //清空列表1选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const columns = [
        {
            title: trans.jobName[Config.backLang],
            dataIndex: 'jobName',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobName') },
        },
        {
            title: trans.jobGroup[Config.backLang],
            dataIndex: 'jobGroup',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobGroup') },
            render: (text) => getJobGroup(text)
        },
        {
            title: trans.invokeTarget[Config.backLang],
            dataIndex: 'invokeTarget',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'invokeTarget') },
        },
        {
            title: trans.jobMessage[Config.backLang],
            dataIndex: 'jobMessage',
            className: 'tableWidth23',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobMessage') },
        },
        {
            title: trans.executeStatus[Config.backLang],
            dataIndex: 'status',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'status') },
            render: (text) => ContextHandler.getMapValueTransalation("executeStatusMap", text)
        },
        {
            title: trans.createdDate[Config.backLang],
            dataIndex: 'createdDate',
            className: 'tableWidth12',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'createdDate') },
            render: (text) => moment(text).format(Config.dateFormatALL)
        },
        /*eslint-disable*/
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'tableWidth10 sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysOperation' onClick={(e) => view(record, e)}><EyeOutlined /> &nbsp;{trans.view[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
            </div>
        },
        /*eslint-disable*/
    ]

    const getJobGroup = (jobGroup) => {
        let model = jobGroupList.find(item => item.code == jobGroup);
        if (model) {
            return model.parmValue1;
        }
        return "";
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        hideDefaultSelections: true,
    };

    return (
        <div id="container" className="template">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                {/* 删除弹框 */}
                {!isDeleteFrame ? '' : <PopupFrame close={deleteFrameClose} content={deleteMsg} />}
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    <div className='systabls'>
                        <div className='sysRow'>
                            <div className='sysCol'>
                                <div className="sysTitle">{trans.jobName[Config.backLang]}</div>
                                <div className="sysSerchInput">
                                    <Input type="text" placeholder={trans.jobName[Config.backLang]} value={searchModel.jobName}
                                        onChange={(e) => searchChange('jobName', e.target.value)}
                                        onKeyDown={(e) => e.key == 13 ? search(pageSize, 1, "N", true) : null} />
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle">{trans.jobGroup[Config.backLang]}</div>
                                <div className="sysSerchInput">
                                    <Select className="sysSelect" placeholder={trans.jobGroup[Config.backLang]}
                                        value={searchModel.jobGroup || ''}
                                        onChange={(e) => searchChange('jobGroup', e)}
                                    >
                                        <Option value=""></Option>
                                        {jobGroupList.map((item) => <Option key={item.code} value={item.code}>{item.parmValue1}</Option>)}
                                    </Select>
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle">{trans.executeStatus[Config.backLang]}</div>
                                <div className="sysSerchInput">
                                    <Select className="sysSelect" placeholder={trans.executeStatus[Config.backLang]}
                                        value={searchModel.status || ''}
                                        onChange={(e) => searchChange('status', e)}
                                    >
                                        <Option value=""></Option>
                                        {context.executeStatusMap.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                    </Select>
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle">{trans.createdDate[Config.backLang]}</div>
                                <div className="sysSerchInput">
                                    <RangePicker onChange={(e) => searchChange('time', e)} format={Config.dateFormat}
                                        value={[searchModel.beginTime, searchModel.endTime]} />
                                </div>
                            </div>
                            <div className="sysSearchButton">
                                <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                            </div>
                        </div>
                        <div className="sysLineEight"></div>
                        <Space size={[5, 5]} wrap className="buttonRelative">
                            {tables.length == 0 ? null :
                                <>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={clearFrameHandler} hidden={Config.funcInfo.canDelete === "N"} icon={<DeleteOutlined />}>{trans.clear[Config.backLang]}</Button>
                                </>
                            }
                        </Space>
                        <div className="sysTable" id="tableOne">
                            <Table
                                scroll={{x: 1200}}
                                rowKey="jobLogId"
                                columns={columns} //列名
                                dataSource={tables} //数据
                                pagination={{  //分页
                                    showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                    onChange: onChange,                        //上页下页或者跳页方法
                                    onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                    total: tablesCount,             //总共多少条数据
                                    current: current,                //当前页
                                    pageSize: pageSize,              //每页显示多少条数据
                                    defaultCurrent: 1,                               //默认当前页为1
                                    size: "small"
                                }}
                                onRow={(record) => {
                                    return {
                                        onClick: event => Base.selectRowNew.call(this, record, 'jobLogId', checkboxState, selectedRowKeys, setCheckboxState, setSelectedRowKeys), // 点击行
                                    };
                                }}
                            />
                        </div>
                    </div>
                </Spin>
                <Modal
                    visible={isView}//控制弹框是否显示
                    title={trans.schedulingLogDetail[Config.backLang]}//标题
                    centered//垂直居中
                    destroyOnClose={true}//关闭即销毁？
                    closable//是否显示右上角的关闭按钮
                    maskClosable={false}//点击蒙层是否允许关闭	
                    width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '40%')}//弹框宽度
                    onCancel={viewClose}//点击取消触发事件
                    footer={
                        <Button key='cancel' className="buttonWhiteStyle" onClick={viewClose} icon={<CloseCircleOutlined />}>{trans.close[Config.backLang]}</Button>
                    }
                >
                    <Row gutter={30}>
                        <Col xs={8} sm={4} md={4} lg={4} className="sysTitle">{trans.jobName[Config.backLang]}</Col>
                        <Col xs={16} sm={8} md={8} lg={8} className="sysTitle">{viewModel.jobName}</Col>
                        <Col xs={8} sm={4} md={4} lg={4} className="sysTitle">{trans.jobGroup[Config.backLang]}</Col>
                        <Col xs={16} sm={8} md={8} lg={8} className="sysTitle">{getJobGroup(viewModel.jobGroup)}</Col>
                    </Row>
                    <Row gutter={30}>
                        <Col xs={8} sm={4} md={4} lg={4} className="sysTitle">{trans.executeStatus[Config.backLang]}</Col>
                        <Col xs={16} sm={8} md={8} lg={8} className="sysTitle">{ContextHandler.getMapValueTransalation("executeStatusMap", viewModel.status)}</Col>
                        <Col xs={8} sm={4} md={4} lg={4} className="sysTitle">{trans.createdDate[Config.backLang]}</Col>
                        <Col xs={16} sm={8} md={8} lg={8} className="sysTitle">{moment(viewModel.createdDate).format(Config.dateFormatALL)}</Col>
                    </Row>
                    <Row gutter={30}>
                        <Col xs={8} sm={4} md={4} lg={4} className="sysTitle">{trans.invokeTarget[Config.backLang]}</Col>
                        <Col xs={16} sm={20} md={20} lg={20} className="sysTitle">{viewModel.invokeTarget}</Col>
                    </Row>
                    <Row gutter={30}>
                        <Col xs={8} sm={4} md={4} lg={4} className="sysTitle">{trans.jobMessage[Config.backLang]}</Col>
                        <Col xs={16} sm={20} md={20} lg={20} className="sysTitle">{viewModel.jobMessage}</Col>
                    </Row>
                    <Row gutter={30}>
                        <Col xs={8} sm={4} md={4} lg={4} className="sysTitle">{trans.exception[Config.backLang]}</Col>
                        <Col xs={16} sm={20} md={20} lg={20} className="sysTitle">{viewModel.exceptionInfo}</Col>
                    </Row>
                </Modal>
            </div>
        </div>
    )

}

export default SchedulingLog;